import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
  const mainSlider = document.getElementById("main_hero_slider");

  const popularProductsSlider = document.querySelectorAll(
    "#popular-products-slider"
  );

  const singleProductSlider = document.getElementById("single-product-slider");
  const singleThumbnailProductSlider = document.getElementById(
    "single-thumbnail-slider"
  );

  const HelpAndAdviceSliders = document.querySelectorAll(
    "#help-and-advice-slider"
  );

  const archiveSlider = document.getElementById(
    "help-and-advice-archive-slider"
  );

  if (mainSlider) {
    const main = new Splide(mainSlider, {
      type: "fade",
      perPage: 1,
      perMove: 1,
      gap: 10,
      focus: "center",
      rewind: true,
      pagination: true,
      arrows: false,
      breakpoints: {
        768: {
          focus: 0,
          gap: 0,
          trimSpace: true,
        },
      },
    });

    const thumbnails = new Splide("#main_hero_thumbnail", {
      fixedWidth: 150,
      fixedHeight: 150,
      gap: 10,
      // focus: "center",
      rewind: true,
      pagination: false,
      arrows: false,
      isNavigation: true,
      // breakpoints: {
      //   600: {
      //     fixedWidth: 60,
      //     fixedHeight: 44,
      //   },
      // },
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }

  if (popularProductsSlider) {
    popularProductsSlider.forEach(function (slider) {
      const numberOfSlides = slider.querySelectorAll(".product-slide").length;
      console.log(numberOfSlides);
      const popularProducts = new Splide(slider, {
        //type: numberOfSlides > 3 ? "loop" : "slide",
        type: "slide",
        perPage: 1,
        perMove: 1,
        gap: "16px",
        focus: "center",
        rewind: true,
        arrows: false,
        pagination: true,
        mediaQuery: "min",
        breakpoints: {
          768: {
            pagination: false,
            perPage: 3,
            //perPage: Math.min(numberOfSlides, 3),
          },
          1200: {
            perPage: 4,
            //perPage: Math.min(numberOfSlides, 4),
            gap: "24px",
          },
          1920: {
            gap: "32px",
          },
        },
      });

      popularProducts.mount();
      const paginationContainer = document.querySelector(
        ".splide-custom-pagination"
      );
      const totalPages = Math.ceil(numberOfSlides / 3);

      for (let i = 0; i < totalPages; i++) {
        const button = document.createElement("button");
        button.textContent = i + 1;
        button.addEventListener("click", () => {
          popularProducts.go(i * 3);
        });
        paginationContainer.appendChild(button);
      }

      popularProducts.on("move", (newIndex) => {
        const buttons = paginationContainer.querySelectorAll("button");
        buttons.forEach((button, index) => {
          button.classList.toggle("active", index === Math.floor(newIndex / 3));
        });
      });

      // Set the first button as active initially
      paginationContainer.querySelector("button").classList.add("active");
    });
  }

  // if (popularProductsSlider) {
  //   const popularProducts = new Splide(popularProductsSlider, {
  //     type: "fade",
  //     perPage: 3,
  //     perMove: 3,
  //     gap: 10,
  //     focus: "center",
  //     rewind: true,
  //     arrows: false,
  //     pagination: true,
  //     mediaQuery: "min",
  //     breakpoints: {
  //       768: {
  //         perPage: 1,
  //         perMove: 1,
  //       },
  //       1200: {
  //         destroy: true,
  //       },
  //     },
  //   });
  //   popularProducts.mount();
  // }

  if (singleProductSlider && singleThumbnailProductSlider) {
    const productSliderSingle = new Splide(singleProductSlider, {
      type: "fade",
      arrows: true,
      cover: true,
      arrows: false,
      focus: "center",
      rewind: true,
      pagination: true,
      perPage: 1,
      perMove: 1,
      mediaQuery: "min",
      breakpoints: {
        768: {
          pagination: false,
        },
      },
    }).mount();

    const thumbnailSliderSingle = new Splide(singleThumbnailProductSlider, {
      fixedWidth: 100,
      fixedHeight: 100,
      isNavigation: true,
      gap: 16,
      focus: "top",
      arrows: false,
      pagination: false,
      height: 565,
      direction: "ttb",
      cover: true,
      breakpoints: {
        600: {
          fixedWidth: 66,
          fixedHeight: 40,
        },
      },
    }).mount();

    productSliderSingle.sync(thumbnailSliderSingle);
    const selector = document.getElementById("pa_size");

    if (selector) {
      selector.addEventListener("change", function () {
        const selectedIndex = this.selectedIndex - 1;
        productSliderSingle.go(selectedIndex);
      });
    }
  }

  if (HelpAndAdviceSliders) {
    HelpAndAdviceSliders.forEach(function (slider) {
      const numberOfSlides = slider.querySelectorAll(
        ".help-and-advice-slide"
      ).length;

      const relatedAdvice = new Splide(slider, {
        type: numberOfSlides > 3 ? "loop" : "slide",
        perPage: 1,
        perMove: 1,
        gap: "16px",
        focus: "left",
        rewind: true,
        arrows: false,
        pagination: false,
        mediaQuery: "min",
        breakpoints: {
          768: {
            perPage: Math.min(numberOfSlides, 3),
          },
          992: {
            gap: "24px",
          },
          1920: {
            gap: "32px",
          },
        },
      });

      relatedAdvice.mount();
      const paginationContainer = document.querySelector(
        ".splide-custom-pagination"
      );
      const totalPages = Math.ceil(numberOfSlides / 3);

      for (let i = 0; i < totalPages; i++) {
        const button = document.createElement("button");
        button.textContent = i + 1;
        button.addEventListener("click", () => {
          relatedAdvice.go(i * 3);
        });
        paginationContainer.appendChild(button);
      }

      relatedAdvice.on("move", (newIndex) => {
        const buttons = paginationContainer.querySelectorAll("button");
        buttons.forEach((button, index) => {
          button.classList.toggle("active", index === Math.floor(newIndex / 3));
        });
      });

      // Set the first button as active initially
      paginationContainer.querySelector("button").classList.add("active");
    });
  }

  if (archiveSlider) {
    const helpSlider = new Splide(archiveSlider, {
      type: "loop",
      perPage: 1,
      perMove: 1,
      gap: 16,
      focus: "center",
      rewind: true,
      arrows: false,
      pagination: true,
      mediaQuery: "min",
      breakpoints: {
        768: {
          perPage: 3,
          perMove: 3,
        },
        992: {
          gap: 24,
        },
        1920: {
          gap: 32,
        },
      },
    }).mount();
  }
});
